import { TAuthmiddleware } from "~/types/global";

const Authmiddleware = ({
  component: Component,
  componentProps,
  layout: Layout,
}: TAuthmiddleware) => {

  return <Layout>
    <Component {...componentProps} />
  </Layout>
}

export default Authmiddleware;
